import React, { useEffect, useRef, useState } from "react";
import "../CustomCSS/SliderComponent.css"; // adjust path if your CSS folder is different

const DEFAULT_IMAGES = [
  "/img/portfolio/01.jpg",
  "/img/portfolio/02.jpg",
  "/img/portfolio/03.jpg",
  "/img/portfolio/04.jpg",
  "/img/portfolio/05.jpg",
];

export default function SliderComponent({
  images = DEFAULT_IMAGES,
  interval = 4000,
  title = "Supatham Ayurvedic Clinic",
  subtitle = "Experience holistic wellness and traditional care",
}) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const containerRef = useRef(null);

  // Touch support
  const touchStartX = useRef(null);

  useEffect(() => {
    if (!images || images.length <= 1) return;
    if (paused) return;

    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, interval);

    return () => clearInterval(id);
  }, [images, interval, paused]);

  // keyboard left / right
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const prev = () => {
    setIndex((i) => (i - 1 + images.length) % images.length);
  };

  const next = () => {
    setIndex((i) => (i + 1) % images.length);
  };

  const goTo = (i) => {
    setIndex(i % images.length);
  };

  const handleMouseEnter = () => setPaused(true);
  const handleMouseLeave = () => setPaused(false);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current == null) return;
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(delta) > 50) {
      if (delta > 0) prev();
      else next();
    }
    touchStartX.current = null;
  };

  return (
    <header
      id="header"
      className="header-carousel"
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {/* Slides */}
      <div className="slides" aria-hidden="true">
        {images.map((src, i) => (
          <div
            key={i}
            className={`slide ${i === index ? "active" : ""}`}
            style={{ backgroundImage: `url(${src})` }}
            role="img"
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Overlay content */}
      <div className="overlay">
        {/* <div className="overlay-inner">
          <h1 className="site-title">{title}</h1>
          <p className="site-subtitle">{subtitle}</p>

          <div className="cta-row">
            <a href="#bookingop" className="btn btn-primary">
              Book Appointment
            </a>
            <a href="#contactus" className="btn btn-ghost">
              Contact Us
            </a>
          </div>
        </div> */}

        {/* Controls */}
        <button
          className="nav-btn prev-btn"
          onClick={prev}
          aria-label="Previous slide"
        >
          ‹
        </button>
        <button
          className="nav-btn next-btn"
          onClick={next}
          aria-label="Next slide"
        >
          ›
        </button>

        {/* Indicators */}
        <div className="indicators" role="tablist" aria-label="Slide indicators">
          {images.map((_, i) => (
            <button
              key={i}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => goTo(i)}
              aria-label={`Go to slide ${i + 1}`}
              aria-current={i === index}
            />
          ))}
        </div>
      </div>
    </header>
  );
}
